import './overview.scss';

class CountdownTimer {
    constructor (element, options) {
        const defaults = {
            seconds: 0
        };

        this.settings = Object.assign({}, defaults, options);
        this.$countdown = element;
        this.$openClearModal = document.querySelector('[data-modal="autoclear-shopping-cart"]');
        this.seconds = parseInt(this.$countdown.getAttribute('data-countdown-value')) || this.settings.seconds;
        if (this.seconds < 0) {
            this.seconds = 0;
        }
        this.updateDisplay();
        this.init();
    }

    init () {
        this.start();
    }

    start () {
        this.interval = setInterval(() => {
            if (this.seconds < 0 || this.seconds === 0) {
                clearInterval(this.interval);
                this.updateDisplay();
                this.$openClearModal.click();
            } else {
                this.seconds--;
                this.updateDisplay();
            }
        }, 1000);
    }

    updateDisplay () {
        const formattedMinutes = Math.floor(this.seconds / 60);
        const formattedSeconds = this.seconds % 60;
        const displayTime = `${String(formattedMinutes).padStart(2, '0')}:${String(formattedSeconds).padStart(2, '0')} min`;
        this.$countdown.innerHTML = displayTime;
    }
}

export { CountdownTimer };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$CountdownTimer = $context.querySelectorAll('[data-countdown="root"]');
        for (let i = 0; i < $$CountdownTimer.length; i++) {
            const $CountdownTimer = $$CountdownTimer[i];

            const CountdownTimerAPI = new CountdownTimer($CountdownTimer);
            $CountdownTimer.API = CountdownTimerAPI;
        }
    }
});
